import React, { useEffect } from "react"
import { usePresence } from "./use-presence"
import { useOnlineUsers, setProvider } from "./presence-store"

// We only want presence tracking enabled on the following pages:
const TRACKING_ENABLED = [
  /^\/campaigns$/, // campaigns index
  /^\/campaigns\/[0-9]+\/draft$/, // campaigns draft page
  /^\/campaigns\/[0-9]+\/share$/, // campaigns share page
  /^\/publications\/[0-9]+\/reports\/(overview|analytics|clicks|recipients)$/ // published campaign page
]

function enabledForCurrentUrl() {
  const pathname = window.location.pathname
  return TRACKING_ENABLED.some(p => p.test(pathname))
}

export function PresenceTracking() {
  const user = window.app?.user

  return enabledForCurrentUrl() ? <PresenceTracker user={user} /> : null
}

export function PresenceTracker({ user }) {
  const { provider } = usePresence(user)

  useEffect(() => {
    if (provider) {
      setProvider(provider)
    }
  }, [provider])

  return window.__debugPresence ? <PresenceDebugger /> : null
}

function PresenceDebugger() {
  const onlineUsers = useOnlineUsers()

  debugLog(onlineUsers)

  return null
}

/* eslint-disable no-console */
function debugLog(onlineUsers) {
  console.groupCollapsed("Presence tracker")
  // Log presence data in a readable format for debugging
  if (onlineUsers.length > 0) {
    console.log(`🟢 ${onlineUsers.length} user(s) online:`)

    onlineUsers.forEach(user => {
      const tabCount = Object.keys(user.tabs).length
      const activeTab = Object.values(user.tabs).find(tab => tab.isActive)
      const currentPage = activeTab?.page || "unknown"

      console.log(`  👤 ${user.name} (${user.email}) - ${tabCount} tab(s)`)
      console.log(`     Currently on: ${currentPage}`)
    })

    // Show detailed tab info in table format
    const tabData = []
    onlineUsers.forEach(user => {
      Object.entries(user.tabs).forEach(([sessionId, tab]) => {
        tabData.push({
          SessionId: sessionId,
          User: user.name,
          Page: tab.page,
          Title:
            tab.title?.substring(0, 30) + (tab.title?.length > 30 ? "..." : ""),
          Active: tab.isActive ? "✅" : "❌",
          "Last Seen": new Date(tab.lastSeen).toLocaleTimeString()
        })
      })
    })

    if (tabData.length > 0) {
      console.table(tabData)
    }
  } else {
    console.log("👻 No other users online")
  }
  console.groupEnd()
}
/* eslint-enable no-console */
